import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Moment from "react-moment";
import Barcode from "react-barcode";

import "./printLayoutSheet.scss";

export const PrintLayoutSheet = ({
  number,
  provider,
  date,
  products,
  setShowPrintLayoutSheet,
  document = 'Поступление'
}) => {

  useEffect(() => {
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setShowPrintLayoutSheet(false);
      }, 200);
    }, 200);
  }, []);

  return (
    <>
      <style>
        {`@media print {
            @page {
              size: A4 landscape;
              margin: 0;
				    }}
          }`
        }
      </style>
      <div className={classNames("printLayoutSheet")}>
        <table>
          <tbody>
            <tr>
              <td >
                {provider &&
                  <div className="providerName">Поставщик: {provider?.label}</div>
                }
                <div className="number">{document} № {number} от <Moment format="DD.MM.YYYY">{date}</Moment> </div>
              </td>
              <td className="barcode">
                {document === 'Поступление' &&
                  <>
                    <Barcode height={40} fontSize={20} value={`S${number}`} format="CODE128" />
                    <Barcode height={40} fontSize={20} value={`P${number}`} format="CODE128" />
                  </>
                }
              </td>
            </tr>
          </tbody>
        </table>
        <table className="print">
          <thead>
            <tr>
              <td>
                Наименование
              </td>
              <td>
                Бренд
              </td>
              <td>
                Артикул
              </td>
              <td>
                Ячейка
              </td>
              <td>
                Кол-во
              </td>
              <td>
                Покупатель
              </td>
              <td>
                Номер заказа
              </td>
              <td>
                Менеджер
              </td>
              <td>
                Остатк
              </td>
            </tr>
          </thead>
          <tbody>
            {products.map(product =>
              <tr key={product.id}>
                <td >
                  {product.nomenclature?.name}
                </td>
                <td>
                  {product.nomenclature?.brand}
                </td>
                <td>
                  {product.nomenclature?.article}
                </td>
                <td>
                  {product.nomenclature?.cell}
                </td>
                <td>
                  {product.count}
                </td>
                <td>
                  {product.customers}
                </td>
                <td>
                  {product.orders?.map(order => order.number).join(',')}
                </td>
                <td>
                  {product.orders?.map(order => order.admin).join(',')}
                </td>
                <td>
                  {product.inStock} {product.inStockAll > 0 && <>({product.inStockAll})</>}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div >
    </>
  );
};